import React from 'react';
import { Link } from 'react-router-dom';
import { HiOutlineArrowRight } from 'react-icons/hi';

function CategoryCard({ category, onSelect }) {
  const handleClick = () => {
    if (onSelect) {
      onSelect(category);
    }
  };
  
  return (
    <Link 
      to={`/category/${category.id}`}
      className="category-card animate-fade-in"
      onClick={handleClick}
    >
      <div className="category-card-emoji">{category.emoji}</div>
      <h3 className="category-card-title">{category.name}</h3>
      <p className="category-card-count">{category.sticker_count} stickers</p>
      <span className="category-card-link">
        Abrir categoria <HiOutlineArrowRight />
      </span>
    </Link>
  );
}

export default CategoryCard;
